import React, { useEffect } from "react";
import "../styles/Toast.css"; // Import the external styles

const DonutProgress = ({ progress }) => {
  const radius = 8;
  const circumference = 2 * Math.PI * radius;
  const progressOffset = circumference - (progress / 100) * circumference;

  return (
    <div className="donut-progress-container">
      <svg width="40" height="40" className="donut-progress">
        <circle cx="20" cy="20" r={radius} className="donut-circle" />
        <circle
          cx="20"
          cy="20"
          r={radius}
          className="donut-progress-circle"
          strokeDasharray={circumference}
          strokeDashoffset={progressOffset}
        />
      </svg>
      <span className="donut-percentage">{progress}%</span>
    </div>
  );
};

export const Toast = ({ id, label, progress, onClose }) => {
  useEffect(() => {
    if (progress === 100) {
      const timeout = setTimeout(() => onClose(id), 2000);
      return () => clearTimeout(timeout);
    }
  }, [progress, id, onClose]);

  return (
    <div className="toast">
      <DonutProgress progress={progress} />
      <div className="flex-1">
        <h4 className="toast-title">{label}</h4>
      </div>
      <button className="toast-close" onClick={() => onClose(id)}>
        ✕
      </button>
    </div>
  );
};

export default Toast;